import * as React from 'react';

import type { WithStyles } from '@material-ui/core';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import { Button } from '@material-ui/core';
import type HistoryStore from 'connect/web/src/stores/history-store';
import type SearchStore from 'connect/web/src/stores/search-store';
import { PackageResponse } from 'tm3-core/api.dtos';
import Image from './controls/image';
import styles from './styles';

import { withStyles } from '@material-ui/core';

interface IProps extends WithStyles<typeof styles> {
  backgroundColor: string;
  historyStore?: HistoryStore;
  searchStore?: SearchStore;
  imageUrl?: string;
  title?: string;
  description?: string;
  packageId?: string;
}

@inject('searchStore', 'historyStore')
@observer
class Offer extends React.Component<IProps> {
  static readonly defaultProps: Partial<IProps> = {
    backgroundColor: '#3D4751'
  };

  render() {
    const { title, description, backgroundColor } = this.props;
    const { container, image, offerContent, offerDescription, offerTitle, root } =
      this.props.classes;

    return (
      <div className={root} style={{ backgroundColor: backgroundColor }}>
        <div className={`container ${container}`}>
          <div className={offerContent}>
            <div className={offerTitle}>{title}</div>
            <div className={offerDescription}>{description}</div>
            <Button color="secondary" variant="contained" onClick={this.onClick}>
              Find out More
            </Button>
          </div>
          <Image className={image} imageUrl={this.imageUrl} />
        </div>
      </div>
    );
  }

  @computed
  private get imageUrl(): string | undefined {
    const { imageUrl } = this.props;
    return !!imageUrl ? `url('/api/online/files/bypath/${imageUrl}') center/cover` : undefined;
  }

  @action.bound
  private onClick(): void {
    const { historyStore, searchStore, packageId } = this.props;
    const { packages } = searchStore!;

    const { urlSlug } = packages.find((p) => p.onlineGuid === packageId) || {};

    if (!urlSlug) {
      return;
    }

    const path = '/packages/' + encodeURI(urlSlug);
    historyStore!.push(path);
  }
}

export default withStyles(styles, { withTheme: true })(Offer);
